'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = init;

var _helpers = require('./_helpers');

var _utils = require('../utils');

var _swiperEsm = require('swiper/dist/js/swiper.esm.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var swiperContainer = context.getElement('.' + context.className + '_Carousel');
  var swiperPaging = context.getElement('.' + context.className + '_Paging');

  var slidesPerView = {
    sm: 1.2,
    md: 2,
    lg: 3,
    xlg: 4
  };

  if (el.getAttribute('data-module-setting-media-breakpoint-md') != null) {
    slidesPerView.md = parseInt(el.getAttribute('data-module-setting-media-breakpoint-md'));
  }

  if (el.getAttribute('data-module-setting-media-breakpoint-lg') != null) {
    slidesPerView.lg = parseInt(el.getAttribute('data-module-setting-media-breakpoint-lg'));
  }

  if (swiperContainer.offsetWidth > 900) {
    slidesPerView.lg = 3;
  }

  var carousel = void 0;
  var currentSizing = void 0;

  makeCarousel();

  window.addEventListener('resize', makeCarousel);

  function makeCarousel() {
    if (currentSizing !== 'desktop' && window.innerWidth >= _utils.mediaBreakpoints.sm && carousel !== undefined) {
      carousel.destroy();
      carousel = undefined;
    } else if (currentSizing !== 'mobile' && window.innerWidth < _utils.mediaBreakpoints.sm && carousel !== undefined) {
      carousel.destroy();
      carousel = undefined;
    }

    if (window.innerWidth > _utils.mediaBreakpoints.sm) {
      var _breakpoints;

      currentSizing = 'desktop';
      carousel = (0, _helpers.initialiseSwiper)(swiperContainer, {
        loop: false,
        watchSlidesProgress: true,
        slidesPerView: slidesPerView.md,
        centeredSlides: false,
        spaceBetween: 15,
        speed: 500,
        slideClass: context.className + '_Slide',
        breakpointsInverse: true,
        breakpoints: (_breakpoints = {}, (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.md, {
          slidesPerView: slidesPerView.md,
          spaceBetween: 30
        }), (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.lg, {
          slidesPerView: slidesPerView.lg,
          spaceBetween: 30
        }), (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.xlg, {
          slidesPerView: slidesPerView.xlg,
          spaceBetween: 30
        }), _breakpoints),
        pagination: {
          el: swiperPaging,
          type: 'bullets',
          clickable: true,
          bulletClass: 'sec-ProductCarousel_Bullet',
          bulletActiveClass: 'sec-ProductCarousel_Bullet-active'
        }
      }, [_swiperEsm.Pagination]);
    } else {
      currentSizing = 'mobile';
      carousel = (0, _helpers.initialiseSwiper)(swiperContainer, {
        loop: false,
        watchSlidesProgress: true,
        slidesPerView: slidesPerView.sm,
        centeredSlides: true,
        spaceBetween: 15,
        speed: 500,
        slideClass: context.className + '_Slide',
        pagination: {
          el: swiperPaging,
          type: 'bullets',
          clickable: true,
          bulletClass: 'sec-ProductCarousel_Bullet',
          bulletActiveClass: 'sec-ProductCarousel_Bullet-active'
        }
      }, [_swiperEsm.Pagination]);
    }
  }
}